import React, { useState, useEffect } from "react";
import { PencilSquareIcon } from "@heroicons/react/16/solid";
import UpdateDesignationForm from "./updateModal";
import { getRequest } from "../../utils/APICall";
import { Spin, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getAllDesignationStart, getAllDesignationSuccess } from "../../redux/designationSlice";

const DesignationTable = () => {
  const T_Head = ["S.NO", "Designation Title", "Action"];
  const { alldesignation, isLoader } = useSelector((state) => state.designation);
  // const [designationData, setDesignationData] = useState([]);
  // const [isLoading, setIsLoading] = useState(true);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [singleDesigData, setSingleDesigData] = useState(null);
  const dispatch = useDispatch()
  const fetchDesignations = async () => {
    try {
      dispatch(getAllDesignationStart())
      const response = await getRequest("getDesignations");
      // console.log(" API response:", response);

      if (response.success) {
        // setDesignationData(response.data);
        dispatch(getAllDesignationSuccess(response?.data))
      } else {
        //console.error(" responce failure:", response.message);
        dispatch(getAllDesignationSuccess([]))
        // message.error(response.message || "Failed to fetch designations");
      }
    } catch (error) {
      dispatch(getAllDesignationSuccess([]))
      console.error("[GET DESIGNATIONS] Error occurred:", error);
      message.error("An error occurred while fetching data");
    } 
  };

  useEffect(() => {
    fetchDesignations();
  }, []);

  const showUpdateModal = (item) => {
    //console.log(" modal data:", item);
    setSingleDesigData(item);
    setIsUpdateModalOpen(true);
  };

  const updateModalCancel = () => {
    setIsUpdateModalOpen(false);
  };

  return (
    <div className="font-[sans-serif] overflow-x-auto">
      <table className="min-w-full bg-white dark:bg-gray-900">
        <thead className="bg-primaryPurple dark:bg-lightgrey">
          <tr>
            {T_Head.map((item, index) => (
              <th
                key={index}
                className="p-4 text-sm md:text-lg font-bold text-white text-center"
              >
                {item}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {isLoader ? (
            Array(10)
              .fill(0)
              .map((_, index) => (
                <tr key={index}>
                  {T_Head.map((_, colIndex) => (
                    <td
                      key={colIndex}
                      className="p-4 border-b border-gray-100 dark:border-gray-700 animate-pulse"
                    >
                      <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
                    </td>
                  ))}
                </tr>
              ))
          ) : alldesignation.length > 0 ? (
            alldesignation.map((item, index) => (
              <tr
                key={index}
                className="even:bg-blue-50 dark:even:bg-gray-700 dark:bg-gray-800 text-center text-gray-900 dark:text-gray-200"
              >
                <td className="p-4 text-sm  ">
                  {index + 1}
                </td>
                {/* <td className="p-4 text-sm  ">
                  {item.CODE}
                </td> */}
                <td className="p-4 text-sm  ">
                  {item.TITLE}
                </td>
                <td className="p-4">
                  <button
                    className="mr-4"
                    onClick={() => showUpdateModal(item)}
                    title="Edit"
                  >
                    <PencilSquareIcon className="h-6 w-6 text-blue-500 dark:text-blue-400 inline" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            /*  PROFESSIONAL NO DATA STATE */
            <tr className="bg-gray-50 dark:bg-gray-800">
              <td colSpan={6}>
                <div className="min-h-[200px] sm:min-h-[300px] lg:min-h-[400px]
                    flex flex-col items-center justify-center
                    text-center gap-2">
                  <p className="animate-pulse text-sm sm:text-base font-medium text-gray-800 dark:text-white">
                    No Designations Available

                  </p>
                  <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
                    There is currently no data to display.
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <UpdateDesignationForm
        visible={isUpdateModalOpen}
        onClose={updateModalCancel}
        singleData={singleDesigData}
      />
    </div>
  );

};

export default DesignationTable;